import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface HomeMobileStickyAction {
  key: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  variant?: "primary" | "destructive" | "outline";
}

interface HomeMobileAdminStickyBarProps {
  actions: HomeMobileStickyAction[];
  className?: string;
}

/** Fixed action bar above bottom nav — keeps primary admin CTAs reachable while scrolling. */
export function HomeMobileAdminStickyBar({
  actions,
  className,
}: HomeMobileAdminStickyBarProps) {
  if (actions.length === 0) return null;

  return (
    <div
      className={cn(
        "fixed inset-x-0 z-40 border-t border-border/80 bg-background/95 px-4 py-2 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:shadow-[0_-4px_16px_rgba(0,0,0,0.35)] md:hidden",
        "bottom-[calc(4rem+env(safe-area-inset-bottom))]",
        className
      )}
      role="toolbar"
    >
      <div className="mx-auto flex max-w-[1400px] flex-col gap-2">
        {actions.map((action) => (
          <Button
            key={action.key}
            type="button"
            variant={
              action.variant === "destructive"
                ? "destructive"
                : action.variant === "outline"
                  ? "outline"
                  : "default"
            }
            className={cn(
              "min-h-[48px] w-full font-bold",
              action.variant === "primary" || !action.variant
                ? "bg-soccer-primary text-black hover:bg-soccer-primary/90"
                : action.variant === "destructive"
                  ? ""
                  : ""
            )}
            disabled={action.disabled}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        ))}
      </div>
    </div>
  );
}
